import { useSettingsStore } from "@/data/settingsStore";

export const STAGING_MODE_ENABLED_KEY = "kaynin_staging_mode_enabled";

export function isStagingModeEnabled() {
  if (typeof window === "undefined") return false;
  return useSettingsStore.getState().getSetting(STAGING_MODE_ENABLED_KEY, false) as boolean;
}

export function setStagingModeEnabled(enabled: boolean) {
  useSettingsStore.getState().updateSetting(STAGING_MODE_ENABLED_KEY, enabled);
}
